import IdExpressIcon from '@/assets/icon/IDExpress.svg';
import JntIcon from '@/assets/icon/J&T Express.svg';
import JneIcon from '@/assets/icon/JNE.svg';
import LionIcon from '@/assets/icon/Lion Parcel.svg';
import NinjaIcon from '@/assets/icon/Ninja Express.svg';
import PosIcon from '@/assets/icon/POS Indonesia.svg';
import RexIcon from '@/assets/icon/Royal Express.svg';
import SapIcon from '@/assets/icon/SAP Express.svg';
import SentralIcon from '@/assets/icon/Sentral Cargo.svg';
import SicepatIcon from '@/assets/icon/SiCepat.svg';
import SpxIcon from '@/assets/icon/SPX.svg';
import TikiIcon from '@/assets/icon/TIKI.svg';
import WahanaIcon from '@/assets/icon/wahana.svg';
import type { CourierOption } from '../components/ShippingSelector/ShippingSelector';
import type { ShippingRate } from '../types/shipping.types';

// Logo per RajaOngkir courier code; a courier without one shows its code in the badge
const COURIER_ICONS: Record<string, string> = {
  ide: IdExpressIcon,
  jne: JneIcon,
  jnt: JntIcon,
  lion: LionIcon,
  ninja: NinjaIcon,
  pos: PosIcon,
  rex: RexIcon,
  sap: SapIcon,
  sentral: SentralIcon,
  sicepat: SicepatIcon,
  spx: SpxIcon,
  tiki: TikiIcon,
  wahana: WahanaIcon,
};
const BADGE_COLOR = 'bg-blue-50 text-blue-500';

/** ShippingSelector id of a rate: courier and service together. */
export const serviceId = (rate: Pick<ShippingRate, 'courier_code' | 'service_code'>) =>
  `${rate.courier_code}:${rate.service_code}`;

/** "2-3 day" -> "Estimasi tiba 2-3 hari"; empty when the API gives no estimate. */
export const estimationLabel = (etd: string | null) =>
  etd?.trim() ? `Estimasi tiba ${etd.trim().replace(/\bdays?\b/gi, 'hari')}` : '';

/** Rates grouped per courier, in the order the API answered (cheapest first). */
export const courierOptions = (rates: ShippingRate[]): CourierOption[] => {
  const byCourier = new Map<string, CourierOption>();
  for (const rate of rates) {
    let option = byCourier.get(rate.courier_code);
    if (!option) {
      option = {
        id: rate.courier_code,
        name: rate.courier_name || rate.courier_code.toUpperCase(),
        icon: COURIER_ICONS[rate.courier_code],
        badgeText: rate.courier_code.toUpperCase(),
        badgeBgColor: BADGE_COLOR,
        services: [],
      };
      byCourier.set(rate.courier_code, option);
    }
    option.services.push({
      id: serviceId(rate),
      // The service name falls back to the code when the API has no description
      name:
        rate.service_name === rate.service_code
          ? rate.service_code
          : `${rate.service_code} - ${rate.service_name}`,
      estimation: estimationLabel(rate.etd),
      price: Number(rate.cost),
    });
  }
  return [...byCourier.values()];
};
